var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductVariantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3043_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 0.0234375L24 4.14844V13.3477L22.5 12.5977V5.82422L16.5 8.82422V11.8477L15 12.5977V8.82422L9 5.82422V8.48438L7.5 7.73438V4.14844L15.75 0.0234375ZM15.75 7.52344L17.8242 6.48047L12.3984 3.375L9.92578 4.61719L15.75 7.52344ZM19.4414 5.68359L21.5742 4.61719L15.75 1.69922L14.0039 2.57812L19.4414 5.68359ZM13.5 13.3477L12 14.0977V14.0859L7.5 16.3359V21.668L12 19.4062V21.0938L6.75 23.7188L0 20.332V12.4102L6.75 9.03516L13.5 12.4102V13.3477ZM6 21.668V16.3359L1.5 14.0859V19.4062L6 21.668ZM6.75 15.0352L11.0742 12.8789L6.75 10.7109L2.42578 12.8789L6.75 15.0352ZM13.5 15.0234L18.75 12.3984L24 15.0234V21.1992L18.75 23.8242L13.5 21.1992V15.0234ZM18 21.7734V18.1992L15 16.6992V20.2734L18 21.7734ZM22.5 20.2734V16.6992L19.5 18.1992V21.7734L22.5 20.2734ZM18.75 16.8984L21.5742 15.4805L18.75 14.0742L15.9258 15.4805L18.75 16.8984Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3043_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductVariantIcon);
export default __webpack_public_path__ + "static/media/product-variant_icon.4518517f057034a583e23b2ad10a05f6.svg";
export { ForwardRef as ReactComponent };